import TVdxbApplicationInviteUserRegistrationComplete from './index.vue';

TVdxbApplicationInviteUserRegistrationComplete.install = app => {
  app.component(TVdxbApplicationInviteUserRegistrationComplete.name, TVdxbApplicationInviteUserRegistrationComplete);
};

export default TVdxbApplicationInviteUserRegistrationComplete;
